// Filter to convert US cents to dollar values
angular.module('pl-shared')
  .filter('centsToDollars', function() {
    return function(inputValue) {
      var centsCount = parseInt(inputValue, 10)
      return centsCount / 100
    }
  })
